<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>代采计划列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
      >
        刷新
      </el-button>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.planid"
                    placeholder="代采计划单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.market_name"
                    placeholder="市场"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    multiple
                    placeholder="请选择城市"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="selectPgid">
                  <el-select
                    v-model="form.purchase_gid"
                    placeholder="选择代采组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectPgid"
                      :key="item.key"
                      :label="item.pgname"
                      :value="item.pgid"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.pg_member_id" placeholder="代采员">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.memberOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="planStatus1">
                  <el-select v-model="form.status" placeholder="代采计划状态">
                    <el-option label="全部" value="-1"></el-option>
                    <el-option
                      v-for="item1 in planStatus1"
                      :key="item1.key"
                      :label="item1.label"
                      :value="item1.key"
                    >
                      {{ item1.label }}
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.ptype" placeholder="生成方式">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item1 in resData.optionPtype"
                      :key="item1.key"
                      :label="item1.label"
                      :value="item1.key"
                    >
                      {{ item1.label }}
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="resData">
                  <el-input
                    v-model="form.stocking_id"
                    placeholder="备货单号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_dispense"
                    placeholder="是否小店分发"
                    clearable
                  >
                    <el-option
                      v-for="item in public_option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.plan_type"
                    placeholder="代采类型"
                    clearable
                  >
                    <el-option
                      v-for="item in purchaseTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="生成时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="完成时间：">
                  <el-date-picker
                    v-model="form.done_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="需求日期：">
                  <el-date-picker
                    v-model="form.demanded_date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button type="success" @click="output(1)">导出</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总&nbsp;&nbsp;&nbsp;&nbsp;：计划代采共{{
          resData.plan_num
        }}件，计{{ resData.plan_price_total }}
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            size="mini"
            @click="showExportDialog = true"
          >
            导出被阻截生成计划的商品
          </el-button>
          <el-button style="margin-left: 10px" size="mini" @click="output(3)">
            导出代采计划商品
          </el-button>
          <el-button
            style="margin-left: 10px"
            type="success"
            size="mini"
            @click="createPlan"
          >
            新建手动计划
          </el-button>
          <el-button size="mini" type="success" @click="createEarlyPlan">
            新建提前代采计划
          </el-button>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <template #content>
              <div>
                <p>
                  手动计划：待开单数据将融入大盘（出现于代采APP的待开单及爆版APP的一手订货单里）；
                </p>
                <p>
                  提前代采计划：待开单数据不融入大盘，需再【代采核单】列表独立开单；
                </p>
              </div>
            </template>
            <i
              class="el-icon-warning-outline"
              style="font-size: 25px; margin-left: 15px; cursor: pointer"
            />
          </el-tooltip>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData.data"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="planid"
              label="代采计划编号"
              width="120"
            >
            </el-table-column>
            <el-table-column align="center" label="生成方式">
              <template #default="{ row }">
                <div>{{ row.ptype_text }}</div>
                <div
                  v-if="row.is_dispense === '1'"
                  style="font-size: 12px; color: blue"
                >
                  小店分发
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="market_name" label="市场">
            </el-table-column>
            <el-table-column align="center" prop="supply_floor" label="楼层">
            </el-table-column>
            <el-table-column align="center" prop="supply_area" label="区域">
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="supply_city" label="城市"></el-table-column>
            <el-table-column
              prop="m_name"
              label="代采员"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="plan_price_total"
              label="计划代采金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="plan_num"
              label="计划代采"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_order_num"
              label="待开单"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_cancel_num"
              label="急救箱"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cancel_num"
              label="已断货"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="finance_wait_confirm_num"
              label="财务待审核"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ok_num"
              label="已完成"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ok_price_total"
              label="已完成金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="生成时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wp_check_time"
              label="审核时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wp_demanded_date"
              width="120"
              sortable
              align="center"
            >
              <template #header>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div style="position: relative; display: inline-block">
                    需求日期<i class="el-icon-info" />
                  </div>
                  <div slot="content">
                    <div>需求日期是用于考核商家履约的起始时间</div>
                    <div>①系统/重采计划：需求日期=当天</div>
                    <div>
                      ②买版/提前代采计划：不融入爆版订货单，不考核，需要日期为空。
                    </div>
                    <div>
                      ③其他计划：免审时为生成时间的次日；需审时，为审核时间的次日
                    </div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="done_time_text"
              label="完成时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status_text"
              label="状态"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              width="200"
            >
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDetail(scope.row)"
                >
                  查看
                </el-button>
                <el-button
                  v-if="scope.row.status == 11"
                  type="text"
                  size="small"
                  @click="handleWithdraw(scope.row)"
                >
                  撤销
                </el-button>
                <el-button type="text" size="small" @click="copy(scope.row)">
                  H5链接
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData.data" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.total"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- 选择导出弹框 -->
    <el-dialog
      :visible.sync="showExportDialog"
      style="text-align: center"
      title="导出被阻截生成计划的商品"
    >
      <el-button
        style="margin-left: auto"
        @click="exportPlanHoldUp(planType.FORECAST_PLAN)"
      >
        提前预测被拦截
      </el-button>
      <el-button
        style="margin-left: 20px"
        @click="exportPlanHoldUp(planType.SYSTEM_PLAN)"
      >
        系统计划被拦截
      </el-button>
    </el-dialog>
    <!-- <file-generate-plan :show="showGeneratePlanDialog" @close="closeImportPlanDialog"></file-generate-plan> -->
  </div>
</template>

<script>
// import FileGeneratePlan from "./PurchasePlan/components/FileGeneratePlan";
import { CITY } from "@/const/CommonConst.js";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "PurchasePlanList",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$route.query.planid) {
        vm.$set(vm.form, "planid", vm.$route.query.planid);
        vm.$set(vm.form, "create_time", []);
      }
    });
  },
  data() {
    return {
      planType: {
        SYSTEM_PLAN: 4,
        FORECAST_PLAN: 17,
      },

      showExportDialog: false,
      resData: {},
      form: {
        create_time: this.defaultDate(),
        done_time: [],
        city: [],
        is_dispense: "", // 是否小店分发 全部（默认）-1
        plan_type: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/wcgPlan/getlist",
      status: -1,
      curPage: 1,
      filterFold: false,
      selectPgid: [],
      selectType: [],
      planStatus1: [],
      multipleSelection: [],
      // showGeneratePlanDialog: false,
      citys: CITY,
      public_option: [
        {
          value: "-1",
          label: "全部",
        },
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      purchaseTypeOptions: [
        {
          value: "-1",
          label: "全部",
        },
        {
          value: "13",
          label: "邀约备货",
        },
        {
          value: "0",
          label: "备货采购",
        },
        {
          value: "14",
          label: "当天备货",
        },
        {
          value: "15",
          label: "加流备货",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
    stringSelection() {
      const newArr = this.multipleSelection.map((item) => {
        return item.planid;
      });
      return newArr.join(",");
    },
  },
  created() {
    this.getSelectData();
  },
  methods: {
    copy(row) {
      this.$http
        .post("/buyer/Purchase/h5ConfirmWaitingPurchase", {
          supply_id: row.supply_id,
          plan_id: row.planid,
        })
        .then((res) => {
          // this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            const url = `${res.data.data.url}\n${row.supply_name}\n${res.data.data.time}`;
            const oInput = document.createElement("textarea");
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$message({
              message: "复制成功",
              type: "success",
            });
            oInput.remove();
          }
        });
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    output(isExcel = 1) {
      this.loading = true;
      this.$http
        .post(this.url, { ...this.filteredForm, is_excel: isExcel })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    exportPlanHoldUp(type) {
      this.loading = true;
      this.$http
        .post("/erp/wcgPlan/exportPlanHoldUp", {
          create_time: this.form.create_time,
          goods_no: this.form.goods_no,
          supply_name: this.form.supply_name,
          plan_type: type,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    getSelectData() {
      this.$http.post("/erp/Common/selectPgid", {}).then((res) => {
        // this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.selectPgid = res.data.data;
        }
      });
      this.$http.post("/erp/wcgPlan/getType", {}).then((res) => {
        // this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.selectType = res.data.data;
        }
      });
      this.$http.post("/erp/wcgPlan/getStatus", {}).then((res) => {
        // this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.planStatus1 = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.tableLoading = true;
      this.$http
        .post(this.url, { ...this.filteredForm, page: val })
        .then((res) => {
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
          }
        });
    },
    handleDetail(row) {
      this.$router.push(`/home/purchaseplandetail/${row.planid}`);
    },

    handleWithdraw(row) {
      this.$confirm("确定撤销?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const url = "/erp/wcgPlan/revoke";
        const data = {
          planid: row.planid,
        };
        this.$http.post(url, data).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.fetchData();
            this.$message({
              type: "success",
              message: "撤销成功!",
            });
          }
        });
      });
    },
    search() {
      this.loading = true;
      this.$http
        .post(this.url, { ...this.filteredForm, page: 1 })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
            this.status = this.filteredForm.status;
            this.curPage = 1;
          }
        });
    },
    selectStatus(key) {
      this.loading = true;
      this.status = key;
      this.$http
        .post(this.url, { ...this.filteredForm, status: key })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
          }
        });
    },
    createPlan() {
      this.$router.push(`/home/purchasing/editplan`);
    },
    // showImportPlanDialog () {
    //     this.showGeneratePlanDialog = true
    // },
    // closeImportPlanDialog (e) {
    //     this.showGeneratePlanDialog = false
    //     if (e.refresh) {
    //         this.search()
    //     }
    // }
    createEarlyPlan() {
      this.$router.push(`/home/purchasing/editplan/1`);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchasePlanList.vue